import { Command, Mark, markInputRule, markPasteRule, mergeAttributes } from '@tiptap/core';

const inputRegex = /`([^`]+)`/;
const pasteRegex = /`([^`]+)`/g;

export const CustomCode = Mark.create({
  name: 'code',

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  excludes: '_',

  code: true,

  exitable: true,

  parseHTML() {
    return [{ tag: 'code' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['code', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },

  // @ts-expect-error
  addCommands() {
    return {
      setCode:
        (): Command =>
        ({ commands }) =>
          commands.setMark(this.name),

      toggleCode:
        (): Command =>
        ({ commands }) =>
          commands.toggleMark(this.name),

      unsetCode:
        (): Command =>
        ({ commands }) =>
          commands.unsetMark(this.name),
    };
  },

  addKeyboardShortcuts() {
    return {
      // @ts-expect-error
      'Mod-e': () => this.editor.commands.toggleCode(),
    };
  },

  addInputRules() {
    return [
      markInputRule({
        find: inputRegex,
        type: this.type,
      }),
    ];
  },

  addPasteRules() {
    return [
      markPasteRule({
        find: pasteRegex,
        type: this.type,
      }),
    ];
  },
});
